class ScrollToTop {
  constructor() {
    this.init = this.init.bind(this);
    this.determineScrollRatio = this.determineScrollRatio.bind(this);
    this.isInViewport = this.isInViewport.bind(this);
    this.init();
  }

  init() {
    const toTopContainer = document.querySelector('[data-to-top]');
    const toTopButton = document.querySelector('[data-to-top-link]');

    if (toTopContainer && toTopButton) {
      window.addEventListener('scroll', () => {
        if (this.determineScrollRatio() > 0.7) {
          toTopContainer.classList.add('to-top--scrolled');
        } else {
          toTopContainer.classList.remove('to-top--scrolled');
        }

        if (!this.isInViewport(toTopContainer)) {
          toTopContainer.classList.add('to-top--sticky');
        } else {
          toTopContainer.classList.remove('to-top--sticky');
        }

      });

      toTopButton.addEventListener('click', function (e) {
        e.preventDefault();

        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }
  }

  determineScrollRatio() {
    return window.scrollY / window.innerHeight;
  }

  isInViewport(el) {
    const rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
    );
  }
}

export default new ScrollToTop();
